import React from "react"
import PropTypes from "prop-types"

import ServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

const SearchServiceCard = ({ service, position, term, path }) => {
  const handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "search",
      object_id: service.module_name,
      object_type: "service",
      position,
      query: term,
    })
  }

  return (
    <li className="service-card-list-item">
      <ServiceCard service={service} onClick={handleOnClick} path={path} />
    </li>
  )
}

SearchServiceCard.propTypes = {
  service: serviceShape.isRequired,
  position: PropTypes.number.isRequired,
  term: PropTypes.string,
  path: PropTypes.string.isRequired,
}

SearchServiceCard.defaultProps = {
  service: {},
}

export default SearchServiceCard
